import React from 'react';
import { ArrowRight } from 'lucide-react';
export function CtaBanner() {
  return <div className="w-full bg-slate-50 border-b border-slate-200 py-2.5 px-4" data-id="element-152">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-3 md:gap-4" data-id="element-153">
        <span className="text-xs md:text-sm font-semibold tracking-wide uppercase text-slate-600" data-id="element-154">
          Discover the Solution
        </span>
        <span className="hidden sm:inline text-slate-300" data-id="element-155">•</span>
        <a href="https://flossfocus.com/products/the-flossfocus-precision" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 bg-orange-500 text-white px-3 py-1.5 rounded text-xs md:text-sm font-semibold hover:bg-orange-600 transition-colors" data-id="element-156">
          Shop Now
          <ArrowRight className="w-3 h-3" data-id="element-157" />
        </a>
      </div>
    </div>;
}